export default __webpack_public_path__ + "static/media/cash-icon-home-mobile.abaa181d.webp";